/**
 * Node Modules
 */
import React from 'react'
import { Helmet } from 'react-helmet'
import delve from 'dlv'
import { Link } from 'gatsby'
import { graphql } from 'gatsby'


/**
 * Application Modules
 */
import PageContainer from '../../components/page-container'
import Header from '../../components/header'
import Footer from '../../components/footer'
import DownloadBanner from '../../components/download-banner'
import Metadata from '../../components/metadata'
import Section from '../../components/section'
import { HeroPrimary, CopyPrimary} from "../../components/typography";
import Spacer from "../../components/spacer";


import './style.css'

const styles = {
  '--logo-color': 'var(--purple)',
  '--color': 'var(--light-purple)',
  '--active-color': 'var(--coral)',
  '--background-color': 'var(--white)',
}

/**
 * Page Component
 */
export default function Page({ data }) {
  const posts = delve(data, 'allContentfulContentPressRelease.nodes', [])

  const {
    referencePressReleaseArchiveMetaData,
  } = data.contentfulSingletonStaticPageMetadata

  return (
    <PageContainer>
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href={`https://kinzoo.com/press-release/`} />
        <meta name="og:url" content="https://kinzoo.com/press-release/" />
      </Helmet>
      <Metadata {...referencePressReleaseArchiveMetaData} />
      <Header styles={styles} />

      <Section className="press-release-hero">
        <div className="press-release-hero__grid grid">
          <div className="column-start-1 column-end-6 column-end-12--t">
            <Spacer size={[50, 100]} />
            <HeroPrimary className={'text-center press-release-hero__hed'}>
              Press Releases
            </HeroPrimary>
            <Spacer size={[10, 40]} />
            <CopyPrimary className={'text-center press-release-hero__dek'}>
              Big things are happening at Kinzoo—and this is where you can keep up with the latest!<br className="tbr"/> Check back often for company news and announcements.
            </CopyPrimary>
            <Spacer size={[20, 30]} />
          </div>
        </div>
      </Section>

      <Section className="press-release-list">
        <Spacer size={[20, 70]} />
        <div className="grid flex flex-center">
          <div className="press-release-list__list
            column-start-1 column-end-6 column-end-12--t">

            {posts
              .map(post => {
                const { publishedDate, title, urlSlug, articleExcerpt } = post
                const image = post.listingImage.file.url

                return (
                  <>
                    <div key={title + publishedDate + urlSlug} className="press-release-list__press-release grid">
                      <div className="press-release__image column-start-1 column-end-6 column-end-12--t column-end-6--d">
                        <Link to={`/press-release/${urlSlug}`} className="press-release-list__image-wrapper">
                          <img className="press-release-list__image" src={`${image}?fit=fill&f=faces&fm=jpg&q=82`} />
                        </Link>
                      </div>

                      <div className="press-release-list__copy column-start-1 column-end-6 column-start-7--d column-end-12--t">
                        <Spacer size={[30, 40]} />
                        <span className="press-release-list__details">{publishedDate}</span>
                        <Spacer size={[24, 20]} />
                        <Link to={`/press-release/${urlSlug}`} className="press-release-list__title">{title}</Link>
                        <Spacer size={[10, 15]} />
                        <Link to={`/press-release/${urlSlug}`} className="press-release-list__description">{articleExcerpt.articleExcerpt}</Link>
                        <Spacer size={[20, 24]} />
                        <Link to={`/press-release/${urlSlug}`} className="press-release-list__read-more">Read More</Link>
                        <Spacer size={[30, 34]} />
                      </div>
                    </div>
                    <Spacer size={[20, 40]} />
                  </>
                )
              })}
              <Spacer size={[60, 60]} />
          </div>
        </div>
      </Section>

      <DownloadBanner />
      <Footer />
    </PageContainer>
  )
}

export const pageQuery = graphql`

  query PressReleaseList {
    contentfulSingletonStaticPageMetadata(contentful_id: {eq: "37wd06meITbnwAFYKdxp70"}) {
      referencePressReleaseArchiveMetaData {
        description
        keywords
        ogDescription
        ogTitle
        ogType
        pageTitle
        twitterCard
        twitterCreator
        twitterDescription
        twitterTitle
        ogImage {
          file {
            url
          }
        }
        twitterImage {
          file {
            url
          }
        }
      }
    }

    allContentfulContentPressRelease(
      sort: { order: DESC, fields: publishedDate }
    ) {
      nodes {
        referencePageMetaData {
          description
          keywords
          ogDescription
          ogTitle
          ogType
          pageTitle
          twitterCard
          twitterCreator
          twitterDescription
          twitterTitle
          ogImage {
            file {
              url
            }
          }
          twitterImage {
            file {
              url
            }
          }
        }
        title
        articleExcerpt {
          articleExcerpt
        }
        urlSlug
        publishedDate(formatString: "MMM DD, YYYY")
        listingImage {
          file {
            url
          }
        }
        referencePageMetaData {
          ogImage {
            file {
              url
            }
          }
        }
      }
    }
  }
`
